import { connect } from 'react-redux';
import { getIsHotelOnly } from 'src/store/view/selectors';
import { getIsNewVariant } from 'src/store/reviews/selectors';
import { getHotelRoulette } from '../../store/selectors/hotel';
import LayoutDesktop from './LayoutDesktop';

const mapStateToProps = (state) => ({
  isRoulette: getHotelRoulette(state),
  isHotelOnly: getIsHotelOnly(state),
  isNew: getIsNewVariant(state),
});

export default connect(mapStateToProps)(LayoutDesktop);
